<template>
    <span>
    <draggable :list="childs"
               class="dragArea list-group-item"
               :options="{draggable:'.item', group:'pages'}"
               :element="'ul'">
        <li v-for="(item, index) in childs" :key="index" class="list-group-item item">
            <div class="form-group row">
                <input type="text" :placeholder="$t('Menüpont neve')" v-model="item.title" class="form-control col-md-4">
                <input type="text" :placeholder="$t('Menüpont linkje')" v-model="item.link" class="form-control col-md-4">
                <button type="button" :title="$t('Menüpont választása')" class="btn btn-info col-md-1" @click="chooseModule(index)"><i class="fa fa-link"></i> </button>
                <button type="button" :title="$t('Törlés')" class="btn btn-danger col-md-1" @click="deleteElement(index)"><i class="fa fa-trash"></i> </button>
                <button class="btn btn-success" :title="$t('Almenü létrehozása')" type="button" @click="addNewSubItem(index)"><i class="fa fa-chevron-down"></i> </button>
            </div>

            <template v-if="item.children && item.children.length > 0">
                <menu-item :childs="item.children">

                </menu-item>
            </template>
        </li>
    </draggable>
        <div class="modal fade" id="chooseModal2"  role="dialog" aria-labelledby="inputModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="chooseModalLabel">{{$t('Choose Module Route')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="m-portlet__body">
                            <div class="row">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item chosen" v-for="(item, index) in routes" v-bind:key="index" @click="setSelectedRoute(item)">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        </span>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MenuItem',
  props: ['childs', 'routes'],
  data () {
    return {
      selected: 0
    }
  },
  components: {draggable},
  methods: {
    deleteElement (index) {
      this.childs.splice(index, 1)
    },
    addNewSubItem (index) {
      this.childs[index].children.push({
        id: 9999,
        title: '',
        children: [],
        icon: 'flaticon-more-1',
        link: ''
      })
      this.$emit('onUpdateMenu', this.menu)
    },
    setSelectedRoute (item) {
      this.childs[this.selected].link = item
      this.selected = 0
      window.$('#chooseModal').modal('hide')
    },
    chooseModule (index) {
      this.selected = index
      window.$('#chooseModal').modal('show')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/menu/MenuItem.vue